import { useTenantTheme } from '@service/tenant/TenantThemeContext';
import { useEffect, useState } from 'react';

export function useLinkShortnerPrefix() {
  const { theme } = useTenantTheme();

  const [prefix, setPrefix] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (theme?.extras?.baseLinkShortUrl) {
      setPrefix(theme.extras.baseLinkShortUrl);
    }
  }, [theme]);

  return prefix;
}
